// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"8351f986","239":"cb6eabc8","453":"6e7705dd","455":"19d03ca3","510":"2db53ee3","614":"cbc3e45f","832":"e3978bbf","977":"ddc3bff2"}[chunkId] + ".chunk.js";
};